'use client';

import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

//* Styles
import SkeletonSliderReviewStyle from './style';

//* Component
import { Image } from '@weareconceptstudio/core';

const SkeletonSliderReview = () => {
	return (
		<SkeletonSliderReviewStyle>
			<Swiper slidesPerView={'auto'}>
				{Array.from({ length: 5 }).map((_, i) => {
					return (
						<SwiperSlide key={i}>
							<Image src={'/images/testimonial-card.svg'} />
						</SwiperSlide>
					);
				})}
			</Swiper>
		</SkeletonSliderReviewStyle>
	);
};

export default SkeletonSliderReview;
